<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size:15px; font-weight: bold">Interchange</small>
      </legend>
      <div>
        <form @submit.prevent="newInterchange()">
          <div class="row">
            <div class="col-md-6">
              <input type="hidden" class="truck_id" :value="Truck.id" />
              <div class="form-group">
                <label>Loading date</label>
                <input type="date" class="form-control loading_date" required />
              </div>
              <div class="form-group">
                <label>Delivery</label>
                <select name="delivery" class="form-control delivery" required>
                  <option value>select Delivey status</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
              <div class="form-group">
                <label>Bond</label>
                <select name="bond" class="form-control bond" required>
                  <option value>select bond status</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Interchange</label>
                <select name="interchange" class="form-control interchange" required>
                  <option value>select Delivey status</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
              <div class="form-group">
                <label>Container number</label>
                <input
                  type="text"
                  class="form-control container_no"
                  placeholder="container number"
                  required
                />
              </div>
              <div class="form-group">
                <label>T1 STATUS</label>
                <select name="t1_status" class="form-control t1_status">
                  <option value="N/A">select T1 status</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
              <div class="form-group">
                <label>Cosignee</label>
                <input type="text" class="form-control consignee" placeholder="cconsignee" required />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat creatingInterchange btn-rounded">
            <i class="fa fa-truck"></i>Add Interchange
          </button>
          <button
            type="button"
            class="btn btn-primary btn-flat creatingInterchangeLoader btn-rounded"
          >
            <i class="fa fa-spinner fa-spin" style="font-size:24px;"></i>please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import $ from "jquery";
import router from "../router";
export default {
  created() {
    if (this.$store.getters.Truck.length === 0) {
      router.push("/manageinterchanges");
    }
  },
  computed: {
    ...mapGetters(["Truck"])
  },
  methods: {
    ...mapActions(["newInterchange"])
  }
};
</script>
<style scoped>
.creatingInterchangeLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/interchanges/interchange.vue